export enum ButtonVariants {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
    QUIET = 'Quiet',
    DANGER_PRIMARY = 'Danger-primary',
    DANGER_SECONDARY = 'Danger-secondary',
    DANGER_QUIET = 'Danger-quiet',
    DEFAULT_CONTEXT_MENU_ITEM = 'Default-context-menu-item',
}

export enum TextPosition {
    LEFT = 'Left',
    CENTER = 'Center',
}

export enum ButtonIconPosition {
    LEFT = 'Left',
    RIGHT = 'Right',
}

export enum ButtonTypes {
    SUBMIT = 'submit',
    RESET = 'reset',
    BUTTON = 'button',
}
